import { type Dispatch, type SetStateAction } from 'react';
import { Button, ButtonVariants } from '@components/button/Button';
import { Modal } from '@components/modal/Modal';
import { ModalActions } from '@components/modal/ModalActions';
import {
  deleteRestaurantBulletin,
  type RestaurantBulletin,
} from './apiHelpers';

export interface DeleteRestaurantBulletinConfirmationModalProps {
  closeModal: () => void;
  bulletin: RestaurantBulletin;
  isOpen: boolean;
  refetchRestaurantBulletins: () => void;
  restaurantId: string;
  setBulletinToDelete: Dispatch<SetStateAction<RestaurantBulletin | undefined>>;
}

export const DeleteRestaurantBulletinConfirmationModal = ({
  closeModal,
  isOpen,
  refetchRestaurantBulletins,
  bulletin,
  restaurantId,
  setBulletinToDelete,
}: DeleteRestaurantBulletinConfirmationModalProps) => {
  const handleDeleteRestaurantBulletin = async (): Promise<void> => {
    closeModal();

    await deleteRestaurantBulletin({
      restaurantBulletinId: bulletin.id,
      restaurantId,
    });

    setBulletinToDelete(undefined);
    refetchRestaurantBulletins();
  };

  const handleClose = (): void => {
    setBulletinToDelete(undefined);
    closeModal();
  };

  return (
    <Modal
      ariaLabel="confirm delete modal"
      isOpen={isOpen}
      onClose={handleClose}
      subtitle={`Are you sure you would like to delete the bulletin “${bulletin.name}”?`}
    >
      <ModalActions>
        <Button
          label="Cancel"
          onClick={handleClose}
          variant={ButtonVariants.Tertiary}
        />
        <Button
          label="Yes, delete bulletin"
          onClick={handleDeleteRestaurantBulletin}
          variant={ButtonVariants.Primary}
        />
      </ModalActions>
    </Modal>
  );
};
